import React, { useContext, useEffect, useState,useRef } from 'react'
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiClient, getAllUsers, getCustomers, ListTaskExpenses, ListTodoByProject, list_project_trans } from '../../../Utility/Api';
import { handlePrint, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from '../../../Utility/UserContext';

const ProjectEmployeeReport = () => {

    const location = useLocation();
    const contentRef = useRef(null);
    const { state } = location;
    const [selectedLanguage, setselectedLanguage] = useState('english')
    const [selectedInvoice, setselectedInvoice] = useState([])
    const [projectTransaction, setProjectTransaction] = useState([])
    const [Expenses, setExpenses] = useState([])
    const [reporttype, setreporttype] = useState(0)
    const [totalAmount, setTotalAmount] = useState();
    const [totalPaidAmount, setTotalPaidAmount] = useState();
    const [Clients, setClients] = useState([])
    const [todo, settodo] = useState([]);
    const [showModal, setshowModal] = useState(false);
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const [users, setUsers] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(""); // Store selected employee ID
    const [filteredEmployees, setFilteredEmployees] = useState(); // Initially, show all employees

    useEffect(() => {
        console.log(state);
        ListProjectTransaction(state?.id)
        List_Task_Expenses(state?.id)
        CustomerList()
        fetchTodo(state?.id)
        fetchUsers()
    }, []);

    const FilterMembers = users.filter(user => user.role_title == 'Employee')

    const ListProjectTransaction = async (id) => {
      try{
        const res = await list_project_trans(id)
        setProjectTransaction(res?.data?.data)
        console.log(res?.data?.data);
        const paid = res?.data?.data
        if (paid.length > 0) {
          const total = paid.reduce((acc, item) => acc + Number(item.amount || 0), 0);
          console.log(total);
          setTotalPaidAmount(total);
        }
      }catch(err){
        console.error(err);
      }
    }
    const CustomerList = async () => {
      try{
        const res = await getCustomers()
        console.log(res?.data?.data);
        setClients(res?.data?.data)
      }catch(err){
        console.error(err);
      }
    }
    const fetchTodo = async (id) => {
      try {
        const response = await ListTodoByProject(id);
        if (response?.data) {
          settodo(response.data.data);
          setFilteredEmployees(response.data.data)
        }
      } catch (error) {
        // toast.error("Error fetching tasks");
      }
    };
    const List_Task_Expenses = async (id) => {
      try{
        const res = await ListTaskExpenses(1,id)
        setExpenses(res?.data?.data)
        console.log(res?.data?.data);
        const expenses = res?.data?.data
        if (expenses.length > 0) {
          const total = expenses.reduce((acc, item) => acc + Number(item.amount || 0), 0);
          console.log(total);
          setTotalAmount(total);
        }
      }catch(err){
        console.error(err);
      }
    }
    const fetchUsers = async (page = 1, text = "") => {
      try {
        const response = await getAllUsers(shopItem?.shop_id);
        if (response.data && response.data.data) {
          console.log(response.data.data);
          setUsers(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to fetch user data");
      }
    };
    const ViewExpensesModal = () => {
      setshowModal(true)
    }
   

const handleEmployeeChange = (event) => {
  const selectedId = event.target.value; // Get selected employee ID
  setSelectedEmployee(selectedId);

  if (selectedId == "") {
    setFilteredEmployees(todo);
  } else {
    const filtered = todo.filter((task) => 
    task.employeeIds.split(",").map(id => id.trim()).includes(selectedId)
  );
    setFilteredEmployees(filtered);
  }
};
  return (
    <>
    <div className="page-wrappers">
      <div className="page-content">
      <NaviGate />
      <div className="card">
          <div className="card-body" ref={contentRef}>
             <>
                  <div className="row mx-3 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-md-1">
                        <img
                          src="assets/images/tech_logo.webp"
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                      <div>
                        <img
                          src="assets/images/arabic.jpg"
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-flex mx-5 mt-3'>
                  <div className="col text-center" >
                    <div className='d-flex'>
                      <h5
                        className="fw-bold "
                      >Project :&nbsp;
                      </h5>
                      <h5 className="fw-bold"> {state?.title}
                      </h5>
                    </div>
                    <div className='d-flex'>
                      <h6
                        className="fw-bold "
                      >Client :&nbsp;
                      </h6>
                      <h6 className="fw-bold"> {Clients.find(item => item.customer_id == state?.client_id)?.name}
                      </h6>
                    </div>
                    </div>
                  <div className="col text-center column-gap-3">
                    <div className='d-flex justify-content-end'>
                      <h6
                        className="fw-bold"
                      >From Date : &nbsp;
                      </h6>
                      <h6 className="fw-bold"> {state?.start_date}
                      </h6>
                      </div>
                      <div className='d-flex justify-content-end'>
                      <h6
                        className="fw-bold "
                      >To Date :&nbsp;
                      </h6>
                      <h6 className="fw-bold"> {state?.end_date}
                      </h6>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 mx-4">
                    <div
                      className="col-md-12"
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundSize: "60%",
                        backgroundPosition: "center",
                      }}
                    >
                      <div>
                      <div className='d-flex justify-content-between align-items-center p-2'>
                          <div className='d-flex column-gap-3'>
                            <div className="font-14 cursor-pointer" style={{color:reporttype == 0 ? '#126EFD' : '', textDecoration:reporttype == 0 ? 'underline' : ''}} onClick={()=>setreporttype(0)}>Project Report</div>
                            <div className="font-14 cursor-pointer" style={{color:reporttype == 1 ? '#126EFD' : '', textDecoration:reporttype == 1 ? 'underline' : ''}} onClick={()=>setreporttype(1)}>Employee Report</div>
                          </div>
                          <div>
                            {reporttype == 1 && 
                          <select class="form-select" onChange={handleEmployeeChange} aria-label="Default select example">
                            <option value="">All Employee</option>
                            {FilterMembers.map((item, index)=>(
                              <option value={item.user_Id}>{item?.full_name}</option>
                            ))}
                          </select>}
                          </div>
                        </div>
                        <div className="bg-dark text-white p-2 rounded-top">
                          <h6 className="mb-0 text-center fw-bold">
                            {reporttype == 0 ? 'Project Report' : 'Employee Report'}
                          </h6>
                        </div>
                      <div className="table-responsive">
                        {/* <table className=" border table-sm table-bordered w-100">
                          <thead className="table-light">
                            <tr className="bg-transparent">
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'الرقم' : 'SL No.'}</span>

                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'التفاصيل' : 'Date'}</span>

                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'الكمية' : 'Title'}</span>

                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'سعر الوحدة' : 'Description'} </span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'الخصم' : 'Estimated Cost'}</span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === 'arabic' ? 'المبلغ الإجمالي' : 'Paid Cost'} </span>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                              <tr>
                                <td>{1}</td>
                                <td>{state?.start_date}</td>
                                <td>{state?.title}</td>
                                <td>{state?.description}</td>
                                <td>{state?.estimation_amount}</td>
                                <td></td>
                              </tr>
                            {Array.isArray(projectTransaction) &&
                              projectTransaction.map((item, index) => (
                                <tr>
                                  <td>{index + 2}</td>
                                  <td>{item.date}</td>
                                  <td>{item.title}</td>
                                  <td>{item.remarks}</td>
                                  <td></td>
                                  <td>{item.amount}</td>
                                </tr>
                              ))}
                          </tbody>

                          <tfoot>
                            <tr>
                              <br />
                            </tr>

                            <tr>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent fw-bold text-end">
                                {selectedLanguage === 'arabic' ? 'الإجمالي' : 'Overall Paid Amount'}
                              </td>
                              <td className="bg-transparent">
                                {state?.paid_amount}
                              </td>
                            </tr>

                            <tr>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent fw-bold text-end">
                                {selectedLanguage === 'arabic' ? 'الخصم' : 'Overall spent'}
                              </td>
                              <td className="bg-transparent">
                                {state?.total_cost}
                              </td>
                            </tr>

                            <tr>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent"></td>
                              <td className="bg-transparent fw-bold text-end">
                                {selectedLanguage === 'arabic' ? 'الضريبة' : 'Profit'}
                              </td>
                              <td className="bg-transparent">
                                {state?.estimation_amount - state?.total_cost}
                              </td>
                            </tr>
                          </tfoot>
                        </table> */}
                        {reporttype == 0 && (
                          <table className="table table-bordered border-dark">
                            <thead>
                              <tr>
                                <th scope="col" className="bg-light">SL.No</th>
                                <th scope="col" className="bg-light">Date</th>
                                <th scope="col" className="bg-light">Title</th>
                                <th scope="col" className="bg-light" style={{ width: "40%" }}>Description</th>
                                <th scope="col" className="bg-light">Estimated Cost</th>
                                <th scope="col" className="bg-light">Incomes</th>
                                <th scope="col" className="bg-light">Expenses</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Project Start Row */}
                              <tr>
                                <td>1</td>
                                <td>{state?.start_date}</td>
                                <td>{state?.title}</td>
                                <td>{state?.description}</td>
                                <td>{state?.estimation_amount}</td>
                                <td>-</td>
                                <td>-</td>
                              </tr>

                              {/* Merge & Sort Transactions */}
                              {([...projectTransaction.filter(item => item.is_paid == 1), ...Expenses]
                                .map((item) => ({
                                  date: item.date || item.created_date?.split("T")[0], // Extract date
                                  title: item.title,
                                  description: item.remarks || item.description || "",
                                  estimatedCost: "-",
                                  income: item.amount && projectTransaction.includes(item) ? item.amount : "-", // Only for projectTransaction
                                  expense: item.amount && Expenses.includes(item) ? item.amount : "-", // Only for Expenses
                                }))
                                .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort by date
                              ).map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 2}</td>
                                  <td>{item.date}</td>
                                  <td>{item.title}</td>
                                  <td>{item.description}</td>
                                  <td>{item.estimatedCost}</td>
                                  <td>{item.income}</td>
                                  <td>{item.expense}</td>
                                </tr>
                              ))}
                            </tbody>
                            <tr><br/></tr>
                            <tfoot>
                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الإجمالي" : "Overall Income"}
                                </td>
                                <td className="bg-transparent">{state?.paid_amount}</td>
                              </tr>

                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الخصم" : "Overall Expenses"}
                                </td>
                                <td className="bg-transparent">{totalAmount}</td>
                              </tr>

                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الضريبة" : "Profit"}
                                </td>
                                <td className="bg-transparent">{state?.paid_amount - totalAmount}</td>
                              </tr>
                            </tfoot>
                            
                          </table>
                        )}
                        <div className='float-end'>
                            <button
                              type="button"
                              className={"btn btn-dark ms-2"}
                              onClick={() => { handlePrint(contentRef) }}
                            >
                              Print
                            </button>
                            </div>

                      {reporttype == 1 &&
                        <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col" className='bg-light'>SL.No</th>
                                <th scope="col" className='bg-light'>Tasks</th>
                                <th scope="col" className='bg-light'>Due Date</th>
                                {/* <th scope="col" className='bg-light' style={{width:'40%'}}>Descripton</th> */}
                                <th scope="col" className='bg-light'>Status</th>
                                <th scope="col" className='bg-light'>Estimated hours</th>
                                <th scope="col" className='bg-light'>Total hours</th>
                              </tr>
                            </thead>
                            <tbody>
                            {Array.isArray(filteredEmployees) &&  
                              filteredEmployees.map((item, index) =>  {
                                // Convert estimated hours to the "00:00:0:00:SS" format
                                const convertToTimeFormat = (hours) => {
                                  const days = Math.floor(hours / 24); // Extract days from hours
                                  const remainingHours = hours % 24; // Remaining hours after extracting days
                                  return `00:00:${days}:${remainingHours.toString().padStart(2, "0")}:00:00`;
                                };
                                const totalSeconds = item.total_hours
                                .split(":")
                                .reduce((acc, val) => acc * 60 + parseInt(val), 0);

                              // Convert estimated_hours to seconds
                              const estimatedSeconds = item.estimated_hours * 3600; // 1 hour = 3600 seconds
                                console.log(item.title,estimatedSeconds);
                                console.log(item.title,totalSeconds);
                              // Determine row color
                              const rowStyle = {
                                backgroundColor:
                                  estimatedSeconds > totalSeconds
                                    ? "darkgreen"
                                    : totalSeconds > estimatedSeconds
                                    ? "darkred"
                                    : "transparent",
                                    color:'white',

                              };
                          
                                return (
                                <tr>
                                  <td >{index + 2}</td>
                                  <td >{item.title}</td>
                                  <td >{item.to_date_time}</td>
                                  <td >{item.status == '0' ? 'In progress' : item.status == '1' ? 'Completed' : item.status == '2' ? 'Cancelled' : item.status == '3' ? 'Yet to start' : ''}</td>
                                  <td >{item.estimated_hours}</td>
                                  <td ><span className='px-2 py-1 rounded-1 font-weight-2' style={rowStyle}>{item.total_hours}</span></td>
                                </tr>
                              )}
                              )}
                          </tbody>
                        </table>}
                        {filteredEmployees?.length == 0 && 
                              <div className='w-100 container-fluid d-flex justify-content-center align-items-center'>
                                  <span><b>No Task Available</b></span>
                              </div>}
                      </div>
                      </div>
                    </div>
                  </div>
                </>
          </div>
        </div>
      </div>
    </div>

    <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" style={{marginTop:'70px'}}>
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                style={{ fontFamily: "Poppins", fontWeight: "bold" }}
              >
                {state?.title} Expenses
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setshowModal(false)}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body" style={{ fontFamily: "Poppins" }}>
              <div className="container">
              <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col" className='bg-light'>SL.No</th>
                                <th scope="col" className='bg-light'>Title</th>
                                <th scope="col" className='bg-light' style={{width:'40%'}}>Descripton</th>
                                <th scope="col" className='bg-light'>Amount</th>
                                <th scope="col" className='bg-light'>Invoice Image</th>
                              </tr>
                            </thead>
                            <tbody>
                            {Array.isArray(Expenses) &&
                              Expenses.map((item, index) => (
                                <tr>
                                  <td>{index + 2}</td>
                                  <td>{item.title}</td>
                                  <td>{item.description}</td>
                                  <td>{item.amount}</td>
                                  <td>
                                    {item.media_urls ? (
                                      <img
                                        src={`${apiClient.defaults.baseURL}${item.media_urls}`} // Construct full URL
                                        alt="Invoice"
                                        width="30"
                                        height="30"
                                      />
                                    ) : (
                                      "No Image"
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                          </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default ProjectEmployeeReport